var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ServiceTypeEnum } from '../core/enums';
import lbsSmartRecommendStop from '../core/lbs/smartRecommendStop';
import { mergeOptions, mergeParams } from '../core/utils';
/**
 * 智能推荐上车点
 * @group 方法
 */
function smartRecommendStop(params, options) {
    var _options = mergeOptions('smartRecommendStop', options);
    var _params = mergeParams(params);
    return lbsSmartRecommendStop(_params, __assign(__assign({}, _options), { serveSort: [ServiceTypeEnum.HELLO] }));
}
export default smartRecommendStop;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbGJzU21hcnRSZWNvbW1lbmRTdG9wL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLGVBQWUsRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUNoRCxPQUFPLHFCQUFxQixNQUFNLGdDQUFnQyxDQUFDO0FBS25FLE9BQU8sRUFBRSxZQUFZLEVBQUUsV0FBVyxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBRzFEOzs7R0FHRztBQUNILFNBQVMsa0JBQWtCLENBQ3pCLE1BQWdDLEVBQ2hDLE9BQXVDO0lBRXZDLElBQU0sUUFBUSxHQUFHLFlBQVksQ0FBQyxvQkFBb0IsRUFBRSxPQUFPLENBQUMsQ0FBQztJQUM3RCxJQUFNLE9BQU8sR0FBRyxXQUFXLENBQUMsTUFBTSxDQUFDLENBQUM7SUFFcEMsT0FBTyxxQkFBcUIsQ0FBQyxPQUFPLHdCQUMvQixRQUFRLEtBQ1gsU0FBUyxFQUFFLENBQUMsZUFBZSxDQUFDLEtBQUssQ0FBQyxJQUNsQyxDQUFDO0FBQ0wsQ0FBQztBQUVELGVBQWUsa0JBQWtCLENBQUMifQ==